import { readRouteWhy } from "../karlRoutes";
import type { BuildCircuitBreakerMap, CircuitBreakerMap } from "./types";

/** Same rule the schematic join uses: "-0F5", "0F5" and "0f5" are one tag. */
const normalizeTag = (value: string): string =>
  value.toUpperCase().replace(/[^A-Z0-9]/g, "");

export const buildCircuitBreakerMap: BuildCircuitBreakerMap = ({ steps }) => {
  const breakers: CircuitBreakerMap = {};
  for (const assignment of steps.assignments) {
    for (const circuit of assignment.circuits) {
      const { circuitId } = circuit;
      if (!circuitId || circuitId in breakers) continue;
      // Read through `readRouteWhy`, never a second join of its own: the row and
      // Karl's card must not disagree about which way in the schematic a run
      // hangs on.
      const why = readRouteWhy({ steps, circuitId });
      const breaker = why.breaker?.trim();
      if (!breaker) continue;
      // `buildWays` falls back to the way's key when the schedule's breaker
      // column is empty, so the two are frequently one name — and a column that
      // repeats the id it displaced says nothing.
      if (why.key && normalizeTag(why.key) === normalizeTag(breaker)) continue;
      breakers[circuitId] = breaker;
    }
  }
  return breakers;
};
